// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UuH5V","right":"styles_right__1C0gw"};